import { API_URL } from "../Constants"
import { startLoading, endLoading, SnackBar } from './Common';
import store from "../store"

export function clearBaselineReducer() {
    return { type: 'CLEAR_BASELINE_STATE' };
}

export function storeDashboard(data) {
    return { type: 'STORE_DASHBOARD_DATA', data };
}

export function storeCurrentScore(score) {
    return { type: 'STORE_CAS_SCORE', score };
}

export function getDashboard() {
    return function (dispatch) {
        dispatch(startLoading())
        dispatch(SnackBar(true, 'Loading.....', 'info'))
        fetch(API_URL + "account/dashboard", {
            method: "GET",
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'Authorization': 'Bearer ' + store.getState().auth.access_token
            }
        }).then(response => response.json(), error => console.log('An error occurred.', error))
            .then((json) => {
                dispatch(storeDashboard(json))
                dispatch(storeCurrentScore(json.current_cas_baseline))
                dispatch(endLoading())
            })
    }
}